<template>
    <div>
      <h2 class="mb-4">Editar Club</h2>
      <form @submit.prevent="submitForm">
        <div class="mb-3">
          <label for="nombre" class="form-label">Nombre:</label>
          <input v-model="club.nombre" type="text" class="form-control" id="nombre" required />
        </div>
  
        <div class="mb-3">
          <label for="direccion" class="form-label">Dirección:</label>
          <input v-model="club.direccion" type="text" class="form-control" id="direccion" />
        </div>
  
        <div class="mb-3">
          <label for="descripcion" class="form-label">Descripción:</label>
          <textarea v-model="club.descripcion" class="form-control" id="descripcion"></textarea>
        </div>
  
        <div class="mb-3">
          <label for="fundacion" class="form-label">Fecha de Fundación:</label>
          <input v-model="club.fundacion" type="date" class="form-control" id="fundacion" />
        </div>
  
        <button type="submit" class="btn btn-primary">Guardar Cambios</button>
      </form>
    </div>
  </template>
  
  <script>
  import axios from '@/axios';
  
  export default {
    props: {
      club_id: {
        type: Number,
        required: true, // Se asegura que el ID del club sea obligatorio
      },
    },
    data() {
      return {
        club: {
          nombre: '',
          direccion: '',
          descripcion: '',
          fundacion: '',
        },
      };
    },
    async created() {
      await this.cargarClub();
    },
    methods: {
      async cargarClub() {
        try {
          // Llama a la API para obtener los datos del club por ID
          const response = await axios.get(`/api/clubes/${this.club_id}`);
          
          
         


          this.club = response.data; // Asigna los datos del club al formulario
           // Convertir la fecha al formato yyyy-MM-dd
           if (this.club.fundacion) {
            this.club.fundacion = new Date(this.club.fundacion).toISOString().split('T')[0];
            }
        } catch (error) {
          console.error('Error al cargar los datos del club:', error);
          alert('No se pudo cargar el club. Por favor, inténtelo de nuevo más tarde.');
        }
      },
      async submitForm() {
        try {
          // Llama a la API para actualizar el club
          const response = await axios.put(`/api/clubes/${this.club_id}`, this.club);
  
          if (response.status === 200) {
            alert('Club actualizado con éxito');
            
            this.$emit('clubActualizado', response.data); // Emite un evento para notificar al padre
          }
        } catch (error) {
          console.error('Error al actualizar el club:', error);
          alert('Hubo un error al intentar actualizar el club.');
        }
      },
    },
  };
  </script>
  
  <style scoped>
  /* Estilos específicos para este componente si es necesario */
  </style>
  